import React from 'react'
import { Edit } from 'react-admin'

import CompetitionsForm from './form'

export const CompetitionsEdit = (props) => (
  <Edit undoable={false} {...props}>
    <CompetitionsForm isEdit={true} {...props} />
  </Edit>
)

export default CompetitionsEdit
